<form [formGroup]="form">
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'protocolList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'signatureDocument.filter.documentCode.label' | translate }}</mat-label>
            <input matInput
              formControlName="documentCode" [(ngModel)]="filter.documentCode">
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'signatureDocument.filter.client.label' | translate }}</mat-label>
            <mat-select #clientSelect formControlName="idClient" [(ngModel)]="filter.idClient">
              @if (clientSelect.focused) {
                <mat-select-filter [displayMember]="'name'" [array]="clients"
                  (filteredReturn)="clientsFiltered =$event"
                  [noResultsMessage]="'common.noResults' | translate"
                [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
              }
              @for (client of clientsFiltered; track client) {
                <mat-option [value]="client.id">
                  {{client.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'signatureDocument.filter.idType.label' | translate }}</mat-label>
            <mat-select #clientSelect formControlName="idType" [(ngModel)]="filter.idType">
              <mat-select-filter [displayMember]="'idType'" [array]="typeDocuments"
                (filteredReturn)="typeDocumentsFiltered =$event"
                [noResultsMessage]="'common.noResults' | translate"
              [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
              @for (type of typeDocumentsFiltered; track type) {
                <mat-option [value]="type.id">
                  {{'signatureDocument.type.'+type?.translation | translate}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <button mat-raised-button (click)="doFilter()" color="primary">{{ 'button.filter' | translate}}</button>
        <button mat-button (click)="cleanFilter()">{{ 'button.clean' | translate }}</button>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</form>